export const WELCOME_SCREEN_INDEX = 1; /* select category and write detail text for option */
export const USER_FORM_INDEX = 2; /* get user info(name, phone, email, kvkk approve) */
export const RESULT_SCREEN_INDEX = 3; /* result text */
